import React, { Fragment } from 'react';
import MainItemSelector from './MainItemSelector';
import Decorator from '../../../functions/decorator';
import PersistenceManager from "../../../functions/persistence";

/**
 * @return {string}
 */
const ItemGroupSection = function(props) {
    let itemGroup = props.itemGroup;
    let items = itemGroup.items;
    let displayName = itemGroup.displayName;
    let isSingleItem = items.length <= 1; // If only 1 item, don't render a select
    let choices = props.choices;
    let handleChangeToSelect = function(changeEvent) {
        changeEvent.preventDefault();
        props.selectMainItem(changeEvent.target.value);
    };

    let mainItemSelector = isSingleItem ? (
        <div>
        </div>
    ) : (
        <Fragment>
            <h4 className="text-branded">{displayName}</h4>
            {<MainItemSelector choice={choices.item} items={items} handleChange={handleChangeToSelect} />}
        </Fragment>
    );
    let doNotDisplay = props.hideButtons && isSingleItem; // Hide this if there's no child elements to display
    return (
        isSingleItem ? '' :
            <div className={`${props.fullWidth ? '' : 'col-lg-4'}`}>
                <div className='container'>
                    <div className="row">
                        <div className={props.fullWidth ? "col-sm text-center mb-3" : "col"}>
                            {mainItemSelector}
                            {isSingleItem ? '' : <div className="container w-75">
                                {/*<hr className="store-bg-accent"/>*/}
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
    )
}
export default ItemGroupSection;
